import { getVersionForClone } from '@qr-front/ui/utils'
import { atom } from 'jotai'

import {
	primaryColorAtom,
	secondaryColorAtom,
} from '@/content-from-sections/client'

import { qrColorSchemeList } from '../../../contentFormSections'
import { isDemoModeAtom } from '../../../generatorState'

export const IMAGES_DEMO_PRIMARY_COLOR = getVersionForClone({
	base: qrColorSchemeList[6].primary,
	clone1: '#8CABB3',
})

export const imagesPrimaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? IMAGES_DEMO_PRIMARY_COLOR : get(primaryColorAtom),
)

export const imagesSecondaryColorAtom = atom((get) =>
	get(isDemoModeAtom) ? 'white' : get(secondaryColorAtom),
)
